import AnimatingDots from '~/components/AnimatingDots';
import Gap from '~/components/Gap';
import Header from '~/components/Header';
import MainContainer from '~/components/MainContainer';
import PaginationBar from '~/components/PaginationBar';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import EmailTable from './EmailTable';
import EmailList from './EmailList';
import EmptyEmailList from './EmptyEmailList';
import { useEmailList } from './hooks/useEmailList';
import { EmailListContext } from './hooks/useEmailListContext';

const Email = () => {
  const {
    isLoading,
    listData,
    listIds,
    totalPages,
    totalCount,
    currentPage,
    fetchSpecificPage,
  } = useEmailList();

  const isDesktop = useIsDesktop();

  return (
    <div>
      <Header headerText="Emails" />

      <MainContainer>
        <EmailListContext.Provider
          value={{
            listIds,
            listData,
          }}
        >
          {!isLoading && listIds.length === 0 && <EmptyEmailList />}
          {listIds.length > 0 && (
            <div className="full-width">
              {isDesktop ? <EmailTable /> : <EmailList />}
              <PaginationBar
                totalItems={totalCount}
                totalPages={totalPages}
                itemsPerPage={10}
                currentPage={currentPage}
                onPageChange={fetchSpecificPage}
                onItemsPerPageChange={() => {}}
              />
            </div>
          )}
        </EmailListContext.Provider>
      </MainContainer>

      {isLoading && (
        <div className="full-width center">
          <AnimatingDots />
        </div>
      )}

      <Gap t={32} />
    </div>
  );
};

export default Email;
